"use client"

import React from "react"
import { useRouter } from "next/router"

export default function LanguageToggle({ style, className }: { style?: React.CSSProperties; className?: string }) {
  const router = useRouter()
  const currentLocale = router.locale || "de"

  const switchLocale = (e?: React.MouseEvent) => {
    if (e) e.preventDefault()
    const newLocale = currentLocale === "de" ? "en" : "de"
    // preserve path and query
    router.push(router.asPath, router.asPath, { locale: newLocale })
  }

  return (
    <button
      onClick={switchLocale}
      aria-label={currentLocale === "de" ? "Switch to English" : "Auf Deutsch wechseln"}
      className={className}
      style={{
        // position: "fixed",
        // top: 20,
        // right: 90,
        // zIndex: 1001,
        padding: "8px 12px",
        borderRadius: 999,
        border: "none",
        cursor: "pointer",
        background: currentLocale === "de" ? "#1BC8CC" : "#265A68",
        color: "white",
        fontWeight: 600,
        boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
        width: "65px",
        ...style,
      }}
    >
      {currentLocale === "de" ? "EN" : "DE"}
    </button>
  )
}
